<template>
    <div class="container">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
            <div class="card-item">
                <div class="card-title">
                    <span>主体信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="mainCode" label="统一社会信用代码 : " prop="mainCode" size="small">
                                <el-input v-model="ruleForm.mainCode" placeholder="请输入" clearable disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="mainName" label="主体名称 : " prop="mainName" size="small">
                                <el-input v-model="ruleForm.mainName" placeholder="请输入" clearable disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="agencyCode" label="法人机构类别 : " prop="agencyCode" size="small">
                                <el-select v-model="ruleForm.agencyCode" placeholder="请选择" clearable>
                                    <el-option v-for="(item,index) in agencyCodeList"
                                               :key="index"
                                               :label="item.text"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item ref="roleTypeArr" label="交易主体角色类型 : " prop="roleTypeArr" size="small">
                                <el-checkbox-group v-model="ruleForm.roleTypeArr" @change="changePublicCheckList">
                                    <div class="all-deal-type">
                                        <div class="item-deal-type">
                                            <div class="item-deal-title">公共资源服务</div>
                                            <div class="item-deal-content">
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox label="1">招标人/采购人/出让人</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox label="2">招标代理/采购代理/经纪代理</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox label="3">投标人/供应商/竞买人</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                        <div class="item-deal-type">
                                            <div class="item-deal-title">政务服务( 中介服务超市 )</div>
                                            <div class="item-deal-content">
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox label="4">项目业主</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-checkbox label="5">涉批中介</el-checkbox>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </div>
                                    </div>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="信用承诺书：" prop="fileList1" size="small">
                                <docUploadForm
                                        :type="type"
                                        :index="0"
                                        :docItem.sync="ruleForm.attachmentParamList[0]"
                                        :fileLists.sync="ruleForm.fileList1"
                                        name="上传附件"
                                        :downBtn1="true"
                                />
                            </el-form-item>
                            <el-form-item v-if="ruleForm.attachmentParamList[1]" label="法人授权委托书：" prop="fileList2" size="small">
                                <docUploadForm
                                        :type="type"
                                        :index="1"
                                        :docItem.sync="ruleForm.attachmentParamList && ruleForm.attachmentParamList[1]"
                                        :fileLists.sync="ruleForm.fileList2"
                                        name="上传附件"
                                        :downBtn2="true"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="card-item">
                <div class="card-title">
                    <span>基本信息</span>
                </div>
                <el-tag closable type="info" v-for="(item,index) in basicInfoList" :key="index"
                        @close="handleCloseBasic()">
                    <p><i class="el-icon-info" style="color: #909399;margin-right: 20px;"></i>{{item}}</p>
                </el-tag>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="businessPhotoAddr" label="营业执照 : " prop="businessPhotoAddr">
                                <imgUpload v-if="ruleForm.mainCode" :ruleForm.sync="ruleForm" :backgroundType="1" :businessPhotoAddr.sync="ruleForm.businessPhotoAddr"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="certName" label="证书名称 : " prop="certName" size="small">
                                <el-input v-model="ruleForm.certName" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                            <el-form-item ref="awardDepart" label="颁发部门 : " prop="awardDepart" size="small">
                                <el-input v-model="ruleForm.awardDepart" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                            <el-form-item ref="businessFailTime" label="证书有效期限至 : " prop="businessFailTime" size="small">
                                <el-date-picker
                                        clearable
                                        v-model="ruleForm.businessFailTime"
                                        type="date"
                                        placeholder="请选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="certNum" label="证书编号 : " prop="certNum" size="small">
                                <el-input v-model="ruleForm.certNum" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                            <el-form-item ref="awardTime" label="颁发日期 : " prop="awardTime" size="small">
                                <el-date-picker
                                        clearable
                                        v-model="ruleForm.awardTime"
                                        type="date"
                                        placeholder="请选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="nation" label="国别/地区 : " prop="nation" size="small">
                                <el-select v-model="ruleForm.nation" placeholder="请选择" clearable>
                                    <el-option v-for="(item,index) in nationList"
                                               :key="index"
                                               :label="item.text"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="registerCapital" label="注册资本 : " prop="registerCapital" size="small">
                                <el-input v-model="ruleForm.registerCapital" placeholder="请输入" clearable>
                                    <i slot="suffix" style="font-style: normal;margin-right: 20px;">万元</i>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="incorporationTime" label="成立日期 : " prop="incorporationTime" size="small">
                                <el-date-picker
                                        clearable
                                        v-model="ruleForm.incorporationTime"
                                        type="date"
                                        placeholder="请选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="unitProperty" label="企业类型 : " prop="unitProperty" size="small">
                                <el-select v-model="ruleForm.unitProperty" filterable placeholder="请选择" clearable>
                                    <el-option v-for="(item,index) in unitPropertyList"
                                               :key="index"
                                               :label="item.text"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="industryCode" label="国民经济行业分类 : " prop="industryCode" size="small">
                                <el-select v-model="ruleForm.industryCode" filterable placeholder="请选择" clearable>
                                    <el-option v-for="(item,index) in industryCodeList"
                                               :key="index"
                                               :label="item.text"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item ref="regionFullCode" label="单位地址 : " prop="regionFullCode" size="small">
                                <div style="display: flex">
                                    <el-cascader
                                            size="small"
                                            :options="options"
                                            v-model="ruleForm.regionFullCode"
                                            @change="basicRegionHandleChange">
                                    </el-cascader>
                                    <el-input class="address" v-model="ruleForm.address"
                                              placeholder="请输入街道 小区 门牌号等信息"
                                              clearable></el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item ref="businessScope" label="经营范围 : " prop="businessScope">
                                <el-input type="textarea" v-model="ruleForm.businessScope" max="100"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="card-item">
                <div class="card-title">
                    <span>联系人信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col>
                            <el-form-item ref="orgAbovePhotoAddr" label="法定代表人身份证信息 : " prop="orgAbovePhotoAddr">
                                <el-row>
                                    <el-col :span="8">
                                        <imgUpload v-if="ruleForm.mainCode" :ruleForm="ruleForm" :backgroundType="2" :orgAbovePhotoAddr.sync="ruleForm.orgAbovePhotoAddr"/>
                                    </el-col>
                                    <el-col :span="8">
                                        <imgUpload v-if="ruleForm.mainCode" :ruleForm="ruleForm" :backgroundType="3" :orgBelowPhotoAddr.sync="ruleForm.orgBelowPhotoAddr"/>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="orgLegal" label="法定代表人 : " prop="orgLegal" size="small">
                                <el-input v-model="ruleForm.orgLegal" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="orgLegalTel" label="法定代表人手机号 : " prop="orgLegalTel" size="small">
                                <el-input v-model="ruleForm.orgLegalTel" placeholder="请输入" maxlength="11" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="orgCertType" label="法定代表人证件信息 : " prop="orgCertType" size="small">
                                <el-select v-model="ruleForm.orgCertType" @change="monitorCardType" placeholder="请选择" clearable>
                                    <el-option v-for="(item,index) in orgCertTypeList"
                                               :key="index"
                                               :label="item.text"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="legalIdCard" label="法定代表人证件号码 : " prop="legalIdCard" size="small">
                                <el-input v-model="ruleForm.legalIdCard" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="responsible" label="负责人 : " prop="responsible" size="small">
                                <el-input v-model="ruleForm.responsible" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="linkPhone" label="负责人手机号 : " prop="linkPhone" size="small">
                                <el-input v-model="ruleForm.linkPhone" placeholder="请输入" maxlength="11" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="infoResponsible" label="申报人 : " prop="infoResponsible" size="small">
                                <el-input v-model="ruleForm.infoResponsible" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="infoResponsiblePhone" label="申报人手机号 : " prop="infoResponsiblePhone" size="small">
                                <el-input v-model="ruleForm.infoResponsiblePhone" placeholder="请输入" maxlength="11"
                                          clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="regionalHead" label="驻本地联系人 : " prop="regionalHead" size="small">
                                <el-input v-model="ruleForm.regionalHead" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="areaResponsibleTel" label="驻本地联系人手机号 : " prop="areaResponsibleTel" size="small">
                                <el-input v-model="ruleForm.areaResponsibleTel" placeholder="请输入" maxlength="11" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="fax" label="公司传真 : " prop="fax" size="small">
                                <el-input v-model="ruleForm.fax" placeholder="请输入" maxlength="20" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item ref="areaFullCode" label="驻本地地址 : " prop="areaFullCode" size="small">
                                <div style="display: flex">
                                    <el-cascader
                                            size="small"
                                            :options="options"
                                            v-model="ruleForm.areaFullCode"
                                            @change="personRegionHandleChange">
                                    </el-cascader>
                                    <el-input class="address" placeholder="请输入街道 小区 门牌号等信息"
                                              v-model="ruleForm.areaAddress"
                                              clearable></el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="card-item">
                <div class="card-title">
                    <span>银行账户信息</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item ref="bankPhotoAddr" label="基本账户扫描件 : " prop="bankPhotoAddr" size="small">
                                <imgUpload v-if="ruleForm.mainCode" :ruleForm="ruleForm" :backgroundType="4" :bankPhotoAddr.sync="ruleForm.bankPhotoAddr"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item ref="mainBank" label="所属银行 : " prop="mainBank" size="small">
                                <el-select v-model="ruleForm.mainBank" placeholder="请选择" clearable>
                                    <el-option v-for="(item,index) in mainBankList"
                                               :key="index"
                                               :label="item.text"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item ref="bankFullCity" label="开户行城市 : " prop="bankFullCity" size="small">
                                <el-cascader
                                        size="small"
                                        :options="options"
                                        v-model="ruleForm.bankFullCity"
                                        @change="bankRegionHandleChange">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item ref="depositBank" label="开户行名称 : " prop="depositBank" size="small">
                                <el-input v-model="ruleForm.depositBank" placeholder="请输入" clearable></el-input>
                            </el-form-item>
                            <el-form-item ref="amountNum" label="基本账户账号 : " prop="amountNum" size="small">
                                <el-input v-model="ruleForm.amountNum" placeholder="请输入" maxlength="30" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-form>
        <div class="bottom-btn">
            <el-button @click="resetForm">取消</el-button>
            <el-button type="primary" @click="submitForm">保存</el-button>
        </div>
        <loadingTel v-if="loadingFlag" />
    </div>
</template>

<script>
    //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
    import {regionData} from 'element-china-area-data'
    import {checkPhone,isIdentityId} from '@/utils/index'
    import {mapState} from 'vuex'
    import dataDictionary from "../../../store/modules/dataDictionary";

    export default {
        name: "main-basicInfo-form",
        props:{
            exitFlag:{
                type: Boolean
            },
            viewFlag:{
                type: Boolean
            }
        },
        data() {
            return {
                loadingFlag:false,
                obj: {},
                type: 'ent_base_info',
                ruleForm: {
                    id:'',
                    mainCode: '',//统一社会信用代码
                    mainName: '',//主体名称
                    agencyCode: '',//法人机构类别
                    roleType: '',//交易主体角色类型
                    roleTypeArr: [],//交易主体角色类型--arr
                    businessPhotoAddr: '',//营业执照
                    certName: '',//证书名称
                    awardDepart: '',//颁发部门
                    businessFailTime: '',//证书有效期限至
                    certNum: '',//证书编号
                    awardTime: '',//颁发日期
                    nation: 'CHN',//国别地区
                    registerCapital: '',//注册资本
                    incorporationTime: '',//成立日期
                    unitProperty: '',//企业类型
                    industryCode: '',//国民经济行业分类
                    regionCode: [],//单位地址
                    regionFullCode: [],//单位地址 -- 展示
                    address: '',//单位地址
                    businessScope: '',//经营范围
                    orgAbovePhotoAddr: '',//法定代表人身份证正面
                    orgBelowPhotoAddr: '',//法定代表人身份证反面
                    orgLegal: '',//法定代表人
                    orgLegalTel: '',//法定代表人手机号
                    orgCertType: '01',//法定代表人证件信息
                    legalIdCard: '',//法定代表人身份证号
                    responsible: '',//负责人
                    linkPhone: '',//负责人手机号
                    infoResponsible: '',//申报人
                    infoResponsiblePhone: '',//申报人手机号
                    regionalHead: '',//驻本地联系人
                    areaResponsibleTel: '',//驻本地联系人手机号
                    areaCode: [],//驻本地地址
                    areaFullCode: [],//驻本地地址 -- 展示
                    areaAddress: '',//驻本地地址
                    fax:'', //公司传真
                    bankPhotoAddr: '',//基本户扫描件
                    mainBank: '',//所属银行
                    depositBank: '',//开户行名称
                    amountNum: '',//基本账户账号
                    bankCity: [],//开户行城市
                    bankFullCity: [],//开户行城市 -- 展示
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                    fileList1:[],//附件类型上传校验
                    fileList2:[],//附件类型上传校验
                },
                rules: {
                    mainCode: [
                        {required: true, message: '请输入社会统一信用代码', trigger: 'blur'},
                    ],
                    mainName: [
                        {required: true, message: '请输入主体名称', trigger: 'blur'},
                    ],

                    agencyCode: [
                        {required: true, message: '请选择法人机构类别', trigger: 'change'},
                    ],
                    certName: [
                        {required: true, message: '请输入证书名称', trigger: 'blur'},
                    ],
                    awardDepart: [
                        {required: true, message: '请输入颁发部门', trigger: 'blur'},
                    ],
                    businessFailTime: [
                        {required: true, message: '请选择证书有效期限至', trigger: 'change'},
                    ],
                    certNum: [
                        {required: true, message: '请输入证书编号', trigger: 'blur'},
                    ],
                    awardTime: [
                        {required: true, message: '请选择颁发日期', trigger: 'change'},
                    ],
                    nation: [
                        {required: true, message: '请选择国别/地区', trigger: 'change'},
                    ],
                    registerCapital: [
                        {required: true, message: '请输入注册资本', trigger: 'blur'},
                    ],
                    incorporationTime: [
                        {required: true, message: '请选择成立日期', trigger: 'blur'},
                    ],
                    unitProperty: [
                        {required: true, message: '请选择企业类型', trigger: 'change'},
                    ],
                    industryCode: [
                        {required: true, message: '请选择国民经济行业分类', trigger: 'change'},
                    ],
                    address: [
                        {required: true, message: '请输入具体地址', trigger: 'blur'},
                    ],
                    businessScope: [
                        {required: true, message: '请输入经营范围', trigger: 'change'},
                    ],
                    orgAbovePhotoAddr: [
                        {required: true, message: '请上传法定代表人正面身份证信息', trigger: 'blur'},
                    ],
                    orgBelowPhotoAddr: [
                        {required: true, message: '请上传法定代表人反面身份证信息', trigger: 'blur'},
                    ],
                    orgLegal: [
                        {required: true, message: '请输入法定代表人', trigger: 'blur'},
                    ],
                    orgLegalTel: [
                        {required: true, validator: checkPhone, message: '请输入正确的法定代表人手机号', trigger: 'blur'},
                    ],
                    orgCertType: [
                        {required: true, message: '请选择法定代表人证件信息', trigger: 'blur'},
                    ],
                    legalIdCard: [
                        {required: true, validator: isIdentityId, message: '请输入有效的法定代表人证件号码', trigger: 'blur'},
                    ],
                    responsible: [
                        {required: true, message: '请输入负责人', trigger: 'change'},
                    ],
                    linkPhone: [
                        {required: true, validator: checkPhone, message: '请输入正确格式的负责人手机号', trigger: 'blur'},
                    ],
                    infoResponsible: [
                        {required: true, message: '请输入申报人', trigger: 'blur'},
                    ],
                    infoResponsiblePhone: [
                        {required: true, validator: checkPhone, message: '请输入正确格式的申报人手机号', trigger: 'blur'},
                    ],
                    regionalHead: [
                        {required: false, message: '请输入驻本地联系人', trigger: 'blur'},
                    ],
                    areaResponsibleTel: [
                        {required: false, message: '请输入正确格式的驻本地联系人手机号', trigger: 'blur'},
                    ],
                    fax: [
                        {required: false, message: '请输入公司传真', trigger: 'blur'},
                    ],
                    areaAddress: [
                        {required: true, message: '请选择法人机构类别', trigger: 'change'},
                    ],
                    bankPhotoAddr: [
                        {required: true, message: '请上传基本户扫描件', trigger: 'change'},
                    ],
                    mainBank: [
                        {required: true, message: '请选择所属银行', trigger: 'change'},
                    ],
                    depositBank: [
                        {required: true, message: '请输入开户行名称', trigger: 'blur'},
                    ],
                    amountNum: [
                        {required: true, message: '请输入基本账户账号', trigger: 'blur'},
                    ],
                    roleTypeArr: [
                        {type: 'array', required: true, message: '请至少选择一种交易主体角色类型', trigger: 'blur'},
                    ],
                    fileList1: [
                        {required: true, message: '请上传诚信承诺书', trigger: 'change'},
                    ],
                    fileList2: [
                        {required: true, message: '请上传法人授权委托书', trigger: 'change'},
                    ],
                    regionFullCode: [
                        {required: true, message: '请选择单位地址', trigger: 'change'},
                    ],
                    areaFullCode: [
                        {required: false, message: '请选择驻本地地址', trigger: 'change'},
                    ],
                    bankFullCity: [
                        {required: true, message: '请选择开户行城市', trigger: 'change'},
                    ],
                    businessPhotoAddr: [
                        {required: true, message: '请上传营业执照', trigger: 'change'},
                    ]
                },
                options: regionData,
                basicInfoList: ['请上传本公司的营业执照 ! 或根据实际情况上传：统一社会信用代码证、 事业单位法人证、团体组织证。'],
                agencyCodes: [],//法人机构类别
            }
        },
        created() {
            this.$store.dispatch('dataDictionary/getAgencyCodeList');//获取法人机构类型列表
            this.$store.dispatch('dataDictionary/getMainBankList');//获取所属银行
            this.$store.dispatch('dataDictionary/getNationList');//获取国别地区
            this.$store.dispatch('dataDictionary/getIndustryCodeList');//获取国民经济行业分类
            this.$store.dispatch('dataDictionary/getOrgCertTypeList');//获取法定代表人证件信息
            this.$store.dispatch('dataDictionary/getUnitPropertyList');//获取企业类型
            this.getBasicInfoMsg();
        },
        computed: {
            ...mapState({
                id:(state) => state.user.orgId,
                entId:(state) => state.user.userinfo.userId,
                agencyCodeList: (state) => state.dataDictionary.agencyCodeList,
                mainBankList: (state) => state.dataDictionary.mainBankList,
                nationList: (state) => state.dataDictionary.nationList,
                industryCodeList: (state) => state.dataDictionary.industryCodeList,
                orgCertTypeList: (state) => state.dataDictionary.orgCertTypeList,
                unitPropertyList: (state) => state.dataDictionary.unitPropertyList,
            })
        },
        methods: {
            // 限制 身份证类型为居民身份证时证件号码的输入才校验规则
            monitorCardType(){
                if(this.ruleForm.orgCertType == '01'){
                    this.rules.legalIdCard= [
                        {required: true, validator: isIdentityId, message: '请输入有效的法定代表人证件号码', trigger: 'blur'},
                    ]
                }else{
                    this.rules.legalIdCard= [
                        {required: true, message: '请输入法定代表人证件号码', trigger: 'blur'},
                    ]
                }
            },
            getBasicInfoMsg(){ //获取用户基本信息
                this.$http.post('/tenderer/entbaseinfo/getbyid?id='+this.id).then(res=>{
                    this.ruleForm = res.data.data;
                    if(res.data.data.attachmentParamList.length > 0){
                        this.ruleForm.attachmentParamList = res.data.data.attachmentParamList;
                        this.ruleForm.fileList1 = res.data.data.attachmentParamList[0];
                        this.ruleForm.fileList2 = res.data.data.attachmentParamList[1];
                    }else{
                        this.ruleForm.attachmentParamList = [{//附件列表
                            Id: "",
                            citeId: "",
                            name: "",
                            fileType: 1,
                            filePath: "",
                            required: false,
                            attributes: {
                                attname: "",
                                delmethod: "2",
                                allows: '.pdf,.PDF'
                            }
                        }];
                        // this.ruleForm.fileList = [];
                    }
                    this.ruleForm.mainCode = res.data.data.mainCode || '';//统一社会信用代码
                    this.ruleForm.mainName = res.data.data.mainName || '';//主体名称
                    this.ruleForm.agencyCode = res.data.data.agencyCode || '';//法人机构类别
                    if(res.data.data.roleType){
                        this.$set(this.ruleForm,'roleTypeArr',res.data.data.roleType.split(','))
                    }else{
                        this.$set(this.ruleForm,'roleTypeArr',[]);
                    }
                    this.ruleForm.businessPhotoAddr = res.data.data.businessPhotoAddr || '';//营业执照
                    this.ruleForm.certName = res.data.data.certName || '';//证书名称
                    this.ruleForm.awardDepart = res.data.data.awardDepart || '';//颁发部门
                    this.ruleForm.businessFailTime = res.data.data.businessFailTime ? res.data.data.businessFailTime.replace(/-/g,'/') : '';//证书有效期限至
                    this.ruleForm.certNum = res.data.data.certNum || '';//证书编号
                    this.ruleForm.awardTime = res.data.data.awardTime ? res.data.data.awardTime.replace(/-/g,'/') : '';//颁发日期
                    this.ruleForm.nation = res.data.data.nation || 'CHN';//国别地区
                    this.ruleForm.registerCapital = res.data.data.registerCapital || '';//注册资本
                    this.ruleForm.incorporationTime = res.data.data.incorporationTime ? res.data.data.incorporationTime.replace(/-/g,'/') : '';//成立日期
                    this.ruleForm.unitProperty = res.data.data.unitProperty || '';//企业类型
                    this.ruleForm.industryCode = res.data.data.industryCode || '';//国民经济行业分类
                    this.ruleForm.address = res.data.data.address || '';//单位地址
                    this.ruleForm.regionCode = res.data.data.regionCode;//单位地址
                    this.ruleForm.regionFullCode = !!res.data.data.regionFullCode ? JSON.parse(res.data.data.regionFullCode) : [];//单位地址 -- 展示
                    this.ruleForm.businessScope = res.data.data.businessScope || '';//经营范围
                    this.ruleForm.orgAbovePhotoAddr = res.data.data.orgAbovePhotoAddr || '';//法定代表人身份证正面
                    this.ruleForm.orgBelowPhotoAddr = res.data.data.orgBelowPhotoAddr || '';//法定代表人身份证反面
                    this.ruleForm.orgLegal = res.data.data.orgLegal || '';//法定代表人
                    this.ruleForm.orgLegalTel = res.data.data.orgLegalTel || '';//法定代表人手机号
                    this.ruleForm.orgCertType = res.data.data.orgCertType || '01';//法定代表人证件信息
                    this.ruleForm.legalIdCard = res.data.data.legalIdCard || '';//法定代表人身份证号
                    this.ruleForm.responsible = res.data.data.responsible || '';//负责人
                    this.ruleForm.linkPhone = res.data.data.linkPhone || '';//负责人手机号
                    this.ruleForm.infoResponsible = res.data.data.infoResponsible || '';//申报人
                    this.ruleForm.infoResponsiblePhone = res.data.data.infoResponsiblePhone || '';//申报人手机号
                    this.ruleForm.regionalHead = res.data.data.regionalHead || '';//驻本地联系人
                    this.ruleForm.areaResponsibleTel = res.data.data.areaResponsibleTel || '';//驻本地联系人手机号
                    this.ruleForm.areaCode = res.data.data.areaCode;//驻本地地址
                    this.ruleForm.areaFullCode = !!res.data.data.areaFullCode ? JSON.parse(res.data.data.areaFullCode) : [];//驻本地地址 -- 展示
                    this.ruleForm.areaAddress = res.data.data.areaAddress || '';//驻本地地址
                    this.ruleForm.bankPhotoAddr = res.data.data.bankPhotoAddr || '';//基本户扫描件
                    this.ruleForm.mainBank = res.data.data.mainBank || '';//所属银行
                    this.ruleForm.depositBank = res.data.data.depositBank || '';//开户行名称
                    this.ruleForm.amountNum = res.data.data.amountNum || '';//基本账户账号
                    this.ruleForm.bankCity = res.data.data.bankCity;//开户行城市
                    this.ruleForm.bankFullCity = !! res.data.data.bankFullCity ? JSON.parse(res.data.data.bankFullCity) : [];//开户行城市 -- 展示
                    this.ruleForm.fax = res.data.data.fax;//公司传真
                    if(this.ruleForm.orgCertType == '01'){
                        this.rules.legalIdCard= [
                            {required: true, validator: isIdentityId, message: '请输入有效的法定代表人证件号码', trigger: 'blur'},
                        ]
                    }else{
                        this.rules.legalIdCard= [
                            {required: true, message: '请输入法定代表人证件号码', trigger: 'blur'},
                        ]
                    }
                })
            },
            changePublicCheckList() {

            },
            //表单提交事件
            submitForm() {
                this.$refs['ruleForm'].validate((valid,object) => {
                    if (valid) {
                        this.ruleForm.id = this.id;
                        let roleTypeStr = this.ruleForm.roleTypeArr;
                        this.ruleForm.roleType = roleTypeStr.join(',');
                        this.loadingFlag = true;
                        this.$http.post('/tenderer/ennftbaseio/save', this.ruleForm).then(res => {
                            if(res.data.code == 1){
                                this.loadingFlag = false;
                                this.$notify({
                                    title: '法人基本信息',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'success'
                                })
                            }else{
                                this.loadingFlag = false;
                                this.$notify({
                                    title: '法人基本信息',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'warning'
                                })
                            }
                        })
                    } else {
                        this.$nextTick(()=>{
                            this.scrollToView(this,object);
                        })
                        return false;
                    }
                });
            },
            //滚动至校验不通过的位置
            scrollToView(_this, object) {
                for (let i in object) {
                    let dom = _this.$refs[i];
                    if (Object.prototype.toString.call(dom) !== "[object Object]") {
                        //这里是针对遍历的情况（多个输入框），取值为数组
                        dom = dom[0];
                    }
                    let top = dom.$el.getBoundingClientRect().top; //获取当前节点的偏移值
                    let scrollTop = document.documentElement.scrollTop; //获取视图滚动值
                    let diff = top + scrollTop;
                    document.documentElement.scrollTop = diff - 276; //276是第一个输入框节点距离顶部的偏移值，也可以在初始化提前保存
                    window.scrollTo(0,diff- 276) //同上
                    break; //因为我们只需要检测一项,所以就可以跳出循环了
                }
            },
            //表单重置事件
            resetForm() {
                this.getBasicInfoMsg();
            },
            //主体信息上传事件
            mainHandleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            mainBeforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            //基本信息文字提示关闭事件
            handleCloseBasic() {
                this.basicInfoList = [];
            },
            //基本信息地区三级联动点击事件
            basicRegionHandleChange(value) {
                this.ruleForm.regionCode = value[value.length - 1];
                this.ruleForm.regionFullCode = value;
            },
            //联系人信息地区三级联动点击事件
            personRegionHandleChange(value) {
                this.ruleForm.areaCode = value[value.length - 1];
                this.ruleForm.areaFullCode = value;
            },
            //银行账户信息地区三级联动事件
            bankRegionHandleChange(value) {
                this.ruleForm.bankCity = value[value.length - 1];
                this.ruleForm.bankFullCity = value;
            },
            fileUploadSuccess(response, file, fileList) {

            },
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        /deep/ .el-input {
            width: 324px;
        }
        /deep/.el-textarea__inner {
            width: 852px;
            height: 156px;
        }
        .address{
            margin-left: 10px;
            width: 36.7%;
        }
        .all-deal-type {
            display: flex;

            .item-deal-type {
                width: 480px;
                border: 1px solid #EEEEEE;
                border-radius: 4px 4px 0px 0px;

                .item-deal-title {
                    width: 100%;
                    height: 45px;
                    background-color: #EFF3F6;
                    border-radius: 2px 2px 0px 0px;
                    border-bottom: 1px solid #EEEEEE;
                    text-align: center;
                    line-height: 45px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }

                .item-deal-content {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            }
            .item-deal-type:nth-child(1){
                .item-deal-content {
                    .el-row{
                        width: 200px;
                    }
                }
            }

            .item-deal-type:nth-last-child(1) {
                border-left: 0;
            }
        }

        .el-tag {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 96%;
            margin: 0 0 0 2%;
            border-radius: 0;
            padding: 0 20px;

            p {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.45);
            }
        }
    }
    @media screen and(max-width: 1680px){
        .container{
            /deep/ .el-input {
                width: 200px;
            }
            .address{
                width: 37.5%;
            }
            /deep/ .el-textarea__inner {
                width: 55.3%;
            }
        }
    }
    @media screen and(max-width: 1600px){
        .container{
            /deep/ .el-input {
                width: 200px;
            }
            .address{
                width: 38%;
            }
            /deep/ .el-textarea__inner {
                width: 620px;
            }
        }
    }
    @media screen and(max-width: 1440px){
        .container{
            /deep/ .el-input {
                width: 150px;
            }
        }
    }
</style>